<template>
  <div>
    <el-form inline :model="searchForm" :loading="searching">
      <el-form-item label="员工手机号">
        <el-input v-model="searchForm.employeePhones" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(1)" />
        </el-input>
      </el-form-item>
      <el-form-item label="业务类型" required>
        <el-select v-model="searchForm.bizType" placeholder="请选择业务类型">
          <el-option
            v-for="item in bizTypes"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建日期" prop="date">
        <el-date-picker type="datetimerange"  value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" v-model="searchForm.date" style="width:100%;"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
        <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" style="margin-top: 1rem" border
              :header-cell-style="{background:'#eee',color:'black'}"
              max-height="600"
              ref="tableView"
    >
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="item.flex"
                       v-if="item.type !== 3 && item.type !== 4"
                       :type="item.type === 2?'selection':''"
      >
      </el-table-column>
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       v-if="item.type === 3"
                       :type="item.type === 2?'selection':''"
      >
        <template slot-scope="scope">
          <el-link v-for="(actionItem, actionIndex) in item.actions" :key="'btn_' + actionIndex" type="primary" @click="btnAction(actionItem, scope.row)">
            {{actionItem.title}}
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 1rem"
                   :page-size.sync="pageSize"
                   :total.sync="totalCount"
                   :current-page.sync="curPage"
                   @size-change="search"
                   @current-change="search"
                   :page-sizes="[20, 100, 200, 500, 1000]"
                   layout="total, sizes, prev, pager, next, jumper"
    />
  </div>
</template>

<script>
import {query} from './dataImportApi'
export default {
  name: 'dataImport',
  data () {
    return {
      searchForm: {
        curPage: 1,
        pageSize: 20,
        date: [],
        employeePhones: '',
        startDate: null,
        endDate: null,
        bizType: null
      },
      bizTypes: [
        {
          id: null,
          text: '全部'
        },
        {
          id: 1,
          text: '员工导入'
        },
        {
          id: 2,
          text: '顾客导入'
        }
      ],
      searching: false,
      multipleEditBoxType: 0,
      tags: [],
      showMultipleEditBox: false,
      multipleEditName: '',
      showEditCustomer: false,
      curPage: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 20,
      list: [],
      listKeyMap: []
    }
  },
  created () {
    this.search()
  },
  methods: {
    search () {
      this.searching = true
      if (this.searchForm.date && this.searchForm.date.length === 2) {
        this.searchForm.startDate = this.searchForm.date[0]
        this.searchForm.endDate = this.searchForm.date[1]
      } else {
        this.searchForm.startDate = null
        this.searchForm.endDate = null
      }
      query(this.searchForm).then(rsp => {
        this.searching = false
        const {code, message, result} = rsp
        if (code === 0) {
          const { pagination, values } = result
          const { list, curPage, pageSize, totalCount, totalPage } = pagination
          this.curPage = curPage
          this.pageSize = pageSize
          this.totalPage = totalPage
          this.totalCount = totalCount
          this.list = list
          this.listKeyMap = values
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.searching = false
      })
    },
    reset () {
      this.searchForm.employeePhones = ''
      this.searchForm.date = []
      this.searchForm.startDate = null
      this.searchForm.endDate = null
      this.searchForm.bizType = null
    },
    addMore (type) {
      this.multipleEditBoxType = type
      const key = this.keyForType(type)
      if (key === null) {
        return
      }
      const tempArray = this.searchForm[key].split(',')
      for (let i = tempArray.length - 1; i >= 0; i--) {
        const tempText = tempArray[i].trim()
        if (tempText.length === 0) {
          tempArray.splice(i, 1)
        }
      }
      this.tags = tempArray
      this.showMultipleEditBox = true
      setTimeout(() => {
        this.$refs.multipleInput.focus()
      }, 100)
    },
    keyForType (type) {
      let key = null
      if (type === 0) {
        key = 'employeePhones'
      } else if (type === 1) {
        key = 'employeePhones'
      } else if (type === 2) {
        key = 'employeePhones'
      } else if (type === 3) {
        key = 'employeePhones'
      } else if (type === 4) {
        key = 'employeePhones'
      }
      return key
    },
    doneAction () {
      this.showMultipleEditBox = false
      const text = this.tags.join(',')
      const key = this.keyForType(this.multipleEditBoxType)
      this.searchForm[key] = text
    },
    clearAction () {
      this.tags = []
      this.multipleEditName = ''
    },
    change () {
      const tempName = this.multipleEditName.trim()
      if (tempName.length === 0) {
        return
      }
      if (this.tags.indexOf(tempName) < 0) {
        this.tags.push(tempName)
      }
      this.multipleEditName = ''
      this.$refs.multipleInput.focus()
    },
    btnAction (action, item) {
      const {type} = action
      if (type === 4) {
        const {code} = action
        const file = item[code]
        window.open(file)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/data/dataImport.vue